import { render, staticRenderFns } from "./CreateDVR.vue?vue&type=template&id=21cc9f16&"
import script from "./CreateDVR.vue?vue&type=script&lang=js&"
export * from "./CreateDVR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports